import isNotNull from "./isNotNull";
import isEmail from "./isEmail";
import isPassword from "./isPassword";
import isPasswordStrength from "./isPasswordStrength";
import isNumber from "./isNumber";
import isLetter from "./isLetter";
import isMin from "./isMin";
import isMinMax from "./isMinMax";
import isMinMaxPhoneNumber from "./isMinMaxPhoneNumber";
import isDate from "./isDate";
import isJson from "./isJson";
import isConfirm from "./isConfirm";
import isMinVal from "./isMinVal";
import isMaxVal from "./isMaxVal";
import isMaxTotalLS from "./isMaxTotalLS";
import isName from "./isName";

export default {
  isNotNull,
  isEmail,
  isPassword,
  isPasswordStrength,
  isNumber,
  isLetter,
  isMin,
  isMinMax,
  isMinMaxPhoneNumber,
  isDate,
  isJson,
  isConfirm,
  isMinVal,
  isMaxVal,
  isMaxTotalLS,
  isName,
};
